import React, { useState, useEffect } from "react";
import backaero from "@assets/icons/backaero.png";
import SC from "./style";
import { apiPost } from "api/callApi";
import Input from "antd/es/input/Input";
import { Loader } from "InnoUI/components";
import { validatePassword } from "utils/config";
import { showAlert } from "utils/helper";

const ResetPassword = ({ email, setShowResetPassword, setCurrentView }) => {
  const [data, setData] = useState({
    otp: "",
    password: "",
    confirmpassword: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [canResendOtp, setCanResendOtp] = useState(true); // Track if OTP can be resent
  const [timer, setTimer] = useState(30); // Timer for cooldown
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    const { otp, password, confirmpassword } = data;

    // Ensure all fields are filled
    if (!otp || !password || !confirmpassword) {
      setError("Please fill all the fields");
      return;
    }

    // Password and confirm password should match
    if (password !== confirmpassword) {
      setError("Password and confirm password do not match");
      return;
    }

    // Validate password (assumed you have a validatePassword function)
    const { isValid, message: validationMessage } = validatePassword(password);
    if (!isValid) {
      setError(validationMessage);
      return;
    }

    setLoading(true); // Set loading state during API call

    try {
      // Make API request to reset password
      const response = await apiPost("/v1/resetpassword", {
        email,
        password,
        otp,
      });

      setLoading(false);

      // Handle the success or error response
      if (response?.success === "success") {
        showAlert({ title: "Success", text: response.message, icon: "success" });
        setCurrentView("login"); // Redirect to login on success
      } else {
        showAlert({ title: "Error", text: response.message, icon: "error" });
      }
    } catch (error) {
      setLoading(false);
      // Handle error response
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || error.message,
        icon: "error",
      });
    }
  };

  const handleChange = (field, value) => {
    setData((prevData) => {
      const updatedData = { ...prevData, [field]: value };
      if (field === "password") {
        const { isValid, message: validationMessage } = validatePassword(value);
        if (!isValid) {
          setError(validationMessage);
        } else {
          setError("");
        }
      }
      return updatedData;
    });
  };

  const onChange = (text) => {
    setData((prevData) => ({ ...prevData, otp: text }));
  };

  const sharedProps = {
    onChange,
  };

  const handleResend = async (e) => {
    e.preventDefault();
    if (!canResendOtp) return;

    try {
      setLoading(true);
      const response = await apiPost("/v1/forgotpasswordotp", { email });

      if (response.success === "success") {
        showAlert({ title: "Success", text: response.message, icon: "success" });
        setData({ ...data, otp: "" });
        setCanResendOtp(false);
        setTimer(30);
      }
    } catch (error) {
      console.error(error);
      setError("Failed to resend OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const togglePasswordVisibility1 = () => {
    setShowPassword1((prev) => !prev);
  };

  useEffect(() => {
    let interval = null;
    if (!canResendOtp) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResendOtp(true);
            clearInterval(interval);
            return 30;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [canResendOtp]);

  return (
    <>
      {SC.Globalstyles}
      {loading && <Loader />}
      <SC.LoginForm>
        <span style={{ color: "green", marginBottom: "10px", padding: "10px" }}>
          An OTP has been sent to your email. Please check your inbox to proceed
          with resetting your password.
        </span>

        <SC.Form onSubmit={handleReset}>
          <div style={{ marginBottom: "20px" }}>
            <Input.OTP
              value={data?.otp}
              formatter={(str) => str.toUpperCase()}
              {...sharedProps}
            />
          </div>
          <SC.PasswordInputContainer>
            <SC.Label style={{ fontSize: "12px" }}>New Password</SC.Label>
            <SC.TransparentInput
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter new password"
              required
              value={data?.password}
              onChange={(e) => handleChange("password", e.target.value)}
            />
            <SC.ToggleButton onClick={togglePasswordVisibility} type="button">
              {showPassword ? <SC.VisibilityIcon /> : <SC.VisibilityOffIcon />}
            </SC.ToggleButton>
          </SC.PasswordInputContainer>
          <SC.PasswordInputContainer>
            <SC.Label style={{ fontSize: "12px" }}>Confirm Password</SC.Label>
            <SC.TransparentInput
              type={showPassword1 ? "text" : "password"}
              name="confirmpassword"
              placeholder="Confirm new password"
              required
              value={data?.confirmpassword}
              onChange={(e) => handleChange("confirmpassword", e.target.value)}
            />
            <SC.ToggleButton onClick={togglePasswordVisibility1} type="button">
              {showPassword1 ? <SC.VisibilityIcon /> : <SC.VisibilityOffIcon />}
            </SC.ToggleButton>
          </SC.PasswordInputContainer>
          {error && (
            <div
              style={{
                color: "red",
                fontWeight: "bold",
                marginBottom: "20px",
                width: "100%",
              }}
            >
              {error}
            </div>
          )}

          <SC.Button type="submit">Reset Password</SC.Button>
        </SC.Form>
        <SC.backButton
          disabled={loading || !canResendOtp}
          onClick={handleResend}
        >
          Resend OTP {canResendOtp ? "" : `(${timer})`}
        </SC.backButton>
        <SC.backButton>
          <span onClick={() => setShowResetPassword(false)}>
            <img
              src={backaero}
              alt="backaero"
              style={{ height: "10px", width: "10px", marginRight: "5px" }}
            />
            Back to Forgot password
          </span>
        </SC.backButton>
      </SC.LoginForm>
    </>
  );
};

export default ResetPassword;
